/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function SelectedText({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#SelectedText_svg__a)"><path d="M13.884 2.21A1.8 1.8 0 0 1 15.5 4v1.1a.6.6 0 0 1-1.2 0V4a.6.6 0 0 0-.6-.6h-2.722v9.2h1.4a.6.6 0 1 1 0 1.2h-4a.6.6 0 0 1 0-1.2h1.4V3.4H7.3a.6.6 0 0 0-.6.6v1.1a.6.6 0 0 1-1.2 0V4a1.8 1.8 0 0 1 1.8-1.8h6.4z" /><path d="M5.1.2a.6.6 0 1 1 0 1.2H3.778v13.2h1.4a.6.6 0 1 1 0 1.2h-4a.6.6 0 1 1 0-1.2h1.4V1.4H1.1a.6.6 0 0 1 0-1.2z" /></g><defs><clipPath id="SelectedText_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;